import type { SessionTotals as Totals } from '@lift2fit/shared-types';
import type { UnitSystem } from '@lift2fit/shared-types';
import { formatVolume } from '@/lib/units';
import { Stat } from './ui';

/**
 * Live session totals. The whole block is an aria-live region so screen-reader
 * users hear volume and PR counts change as sets are logged (UI/UX spec §4.2).
 */
export function SessionTotals({
  totals,
  compliancePct,
  unit,
  className,
}: {
  totals: Totals;
  compliancePct: number;
  unit: UnitSystem;
  className?: string;
}) {
  return (
    <div
      aria-live="polite"
      aria-atomic="false"
      className={className ?? 'grid grid-cols-2 gap-x-6 gap-y-4 sm:grid-cols-4'}
    >
      <Stat label="Volume" value={formatVolume(totals.volumeKg, unit)} />
      <Stat
        label="Sets"
        value={`${totals.setsCompleted}/${totals.setsPrescribed}`}
        hint={`${compliancePct}% of the prescription`}
      />
      <Stat
        label="PRs"
        value={totals.prCount}
        tone={totals.prCount > 0 ? 'accent' : 'default'}
        hint={totals.prCount > 0 ? 'new personal records' : 'none yet today'}
      />
      <Stat
        label="Avg RPE"
        value={totals.avgRpe === null ? '—' : totals.avgRpe.toFixed(1)}
        hint={totals.failedSets > 0 ? `${totals.failedSets} failed set${totals.failedSets === 1 ? '' : 's'}` : 'all sets clean'}
      />
    </div>
  );
}
